import { Injectable, OnDestroy } from '@angular/core';

@Injectable()
export class PostMessageService implements OnDestroy {
  private listeners: { [eventName: string]: Function[] } = {};
  private messageHandler: (e: MessageEvent) => void;

  constructor() {
    this.messageHandler = this.handleMessage.bind(this);
    window.addEventListener('message', this.messageHandler);
  }

  public addListener(eventName: string, fn: Function) {
    if (!this.listeners[eventName]) {
      this.listeners[eventName] = [];
    }
    this.listeners[eventName].push(fn);
  }

  public ngOnDestroy() {
    window.removeEventListener('message', this.messageHandler);
    this.listeners = {};
  }

  public send(recipient, eventName, data = null) {
    if (!recipient) {
      return;
    }
    recipient.postMessage(
      JSON.stringify({ name: `burt-${eventName}`, data: data }),
      '*', // origin
    );
  }

  private handleMessage(e: MessageEvent) {
    if (typeof e.data === 'string' && e.data.includes('burt-')) {
      const data = JSON.parse(e.data);
      const name = data['name'].slice(5);
      if (this.listeners[name]) {
        this.listeners[name].forEach(listener => listener(data['data']));
      }
    }
  }
}
